import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import layout from "../../constants/layout";
function ContentBox({ children, sx, ...paperProps }) {
  return (
    <Box sx={sx || {}}>
      <Paper
        elevation={layout.ContentBoxElevation}
        {...paperProps}
        sx={{
          padding: "1rem",
          height: "100%",
          overflowY: "auto",
        }}
      >
        {children}
      </Paper>
    </Box>
  );
}

export default ContentBox;
